module.exports = __webpack_public_path__ + "static/media/twitter.b66469bf.svg";